import React from "react";
import { formatCurrency } from "../../../helpers/estimateTotals";
import { ReportRule } from "../../report/ReportRule";

export function EstimateReportSummarySection({ summary }) {
  if (!summary) return null;

  return (
    <>
      <ReportRule variant="preview" />
      <h2 className="er-section-title">Estimate Summary</h2>
      <div className="er-report-panel">
        <div className="er-summary-row">
          <span>Materials Total</span>
          <span>{formatCurrency(summary.materialsTotal)}</span>
        </div>
        <div className="er-summary-row">
          <span>Labour Total</span>
          <span>{formatCurrency(summary.labourTotal)}</span>
        </div>
        {summary.hasAdjustments && (
          <>
            {summary.wasteAdjustment !== 0 && (
              <div className="er-summary-row">
                <span>Waste Adjustment</span>
                <span>{formatCurrency(summary.wasteAdjustment)}</span>
              </div>
            )}
            {summary.travelAdjustment !== 0 && (
              <div className="er-summary-row">
                <span>Travel Adjustment</span>
                <span>{formatCurrency(summary.travelAdjustment)}</span>
              </div>
            )}
            {summary.miscAdjustment !== 0 && (
              <div className="er-summary-row">
                <span>Misc Adjustment</span>
                <span>{formatCurrency(summary.miscAdjustment)}</span>
              </div>
            )}
          </>
        )}
        <div className="er-summary-row er-summary-row--emphasis">
          <span>
            {summary.usesFinalPrice ? "Final Estimate Total" : "Estimate Total"}
          </span>
          <span>{formatCurrency(summary.estimateTotal)}</span>
        </div>
      </div>
    </>
  );
}
